import resourceService from './resource_service';

const modelName = 'chemical-type';

const attributes = {
  name: '',
};

const relationships = {
  chemicals: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships);
